import { render, staticRenderFns } from "./MileageAdmin.vue?vue&type=template&id=29a1215a&scoped=true&"
import script from "./MileageAdmin.vue?vue&type=script&lang=js&"
export * from "./MileageAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MileageAdmin.vue?vue&type=style&index=0&id=29a1215a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a1215a",
  null
  
)

export default component.exports